<div class="container-fluid">
    <div class="content-row">
        <!-- Mobile Header -->
        <div class="mobile-header d-lg-none" (click)="toggleMobileMenu()">
            <div class="d-flex align-items-center justify-content-between w-100">
                <div class="d-flex align-items-center">
                    <div class="user-avatar-container mobile-avatar me-3">
                        <img [src]="userAvatar" [alt]="userFirstName" class="user-avatar w-100 rounded-circle" (error)="onImageError($event)">
                    </div>
                    <div class="d-flex align-items-center gap-1">
                        <h6 class="welcom mb-0">Bienvenue,</h6>
                        <h5 class="username">{{ username }}</h5>
                    </div>
                </div>
                <div class="toggle-icon">
                    <img [src]="isMobileMenuOpen ? './assets/images/icons/times.svg' : './assets/images/icons/menu-drop.png'" alt="toggle menu" class="toggle-arrow">
                </div>
            </div>
        </div>

        <!-- Left Sidebar -->
        <div class="sidebar" [class.mobile-open]="isMobileMenuOpen">
            <div class="sidebar-sticky">
                <!-- Desktop User Info -->
                <div class="desktop-user-info d-none d-lg-block text-center mb-4">
                    <div class="user-avatar-container mx-auto mb-3">
                        <img [src]="userAvatar" [alt]="userFirstName" class="user-avatar rounded-circle" (error)="onImageError($event)">
                    </div>
                    <div class="d-flex justify-content-center gap-1">
                        <h6 class="welcom mb-1">Bienvenue,</h6>
                        <h5 class="username">{{ username }}</h5>
                    </div>
                </div>

                <ul class="nav flex-column">
                    @for (item of menuItems; track item.path) {
                    <li class="nav-item">
                        <a class="nav-link d-flex align-items-center" [routerLink]="item.path" routerLinkActive="active" #rla="routerLinkActive" [routerLinkActiveOptions]="{ exact: false }" (click)="closeMobileMenu()">
                            <img [src]="rla.isActive ? item.iconActive : item.icon" class="me-2" /> {{ item.label }}
                        </a>

                    </li>
                    }
                </ul>

                <div class="mt-4">
                    <button class="btn w-100 d-flex align-items-center justify-content-center" (click)="onLogout.emit()">
                        <img src="./assets/images/icons/dashboard/logout.png" alt="logout icon" class="me-2">
                        Se déconnecter
                    </button>
                </div>
            </div>
        </div>

        <!-- Main Content -->
        <div class="main-content">
            <ng-content></ng-content>
        </div>
    </div>
</div>